import { useConfigs } from "./useConfigs";
import { useDefinition } from "./useDefinition";

/**
 * Check if AI import is allowed
 * Default is true, can be disabled via Clover config "Creator.DisableAiImport"
 */
function useAllowAiImport() {
	const [[disableAiImport], isConfigsPending] = useConfigs([
		{ key: "Creator.DisableAiImport" } as unknown as eXpress.core.ConfigRequest,
	]);
	return isConfigsPending
		? false // If fetching config: false to prevent flickering
		: !disableAiImport
		? true // If not configured: true
		: disableAiImport.toLowerCase() !== "true";
}

/**
 * Show AI import button?
 * Also checks if the product is an AI product and is AI is not disabled
 */

export function useShowAiImport() {
	const allowAiImport = useAllowAiImport();
	const { isAiProductOrDesign } = useDefinition() || {};
	return !!(allowAiImport && isAiProductOrDesign);
}
